(function() {
'use strict';

angular
    .module('TR')
    .controller('ConnectingAirport', ConnectingAirport);

function ConnectingAirport($window, $routeParams, bookingService, tripService) {
    const cm = this;

    cm.setDestinationAirport = undefined;

    tripService.getTrip($routeParams.tripId).then(function(trip) {
        bookingService.getBooking(trip.BookingId).then(function(booking) {
            const cf = booking.UserData.ConnectingFlight;
            cm.setDestinationAirport = function(airport) {
                cf.OutboundDestinationAirport = airport.Code;
                cf.OutboundDestinationAirportName =
                    String.format('{0} ({1})', airport.Title, airport.Code);
                bookingService.updateBooking(booking);
                $window.history.back();
            };
        });
    });
}
})();
